import { type ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { Spinner } from '@/components/ui/spinner'
import { usePermissions } from '@/lib/hooks/use-permissions'
import type { PermissionName } from '@/types/db'

type PermissionGateProps = {
  permission: PermissionName | ReadonlyArray<PermissionName>
  mode?: 'all' | 'any'
  children: ReactNode
}

export function PermissionGate({
  permission,
  mode = 'all',
  children,
}: PermissionGateProps) {
  const { has, loading } = usePermissions()

  if (loading) {
    return (
      <div className="flex h-full items-center justify-center py-12">
        <Spinner label="Đang kiểm tra quyền..." />
      </div>
    )
  }

  const perms = Array.isArray(permission) ? permission : [permission]
  const granted = mode === 'any' ? perms.some(has) : perms.every(has)

  if (!granted) {
    return <Navigate to="/403" replace />
  }

  return <>{children}</>
}
